import { render, staticRenderFns } from "./ModalListItems.vue?vue&type=template&id=cc48ab44&scoped=true"
import script from "./ModalListItems.vue?vue&type=script&lang=ts"
export * from "./ModalListItems.vue?vue&type=script&lang=ts"
import style0 from "./ModalListItems.vue?vue&type=style&index=0&id=cc48ab44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc48ab44",
  null
  
)

export default component.exports